import React, { useCallback, useState } from 'react';
import ReactInputMask from 'react-input-mask';

import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

export default function Input({ disabled, onChangeInput, error, ...props }) {
  const [isError, setIsError] = useState(false);

  const handleChange = useCallback((data) => {
    if (data.indexOf('_') === -1) {
      const value = data.split(':');

      if (Number(value[0]) > 23 || Number(value[1]) > 59) {
        setIsError(true);
      } else {
        setIsError(false);
      }

      onChangeInput(data);
    }
  }, []);

  if (disabled)
    return (
      <TextField
        {...props}
        fullWidth
        variant="outlined"
        size="small"
        InputLabelProps={{ shrink: true }}
        disabled
      />
    );

  return (
    <ReactInputMask
      {...props}
      mask="99:99"
      placeholder="__:__"
      onChange={({ target }) => handleChange(target.value)}
      error={isError || error}
    >
      {(inputProps) => (
        <TextField
          {...inputProps}
          fullWidth
          variant="outlined"
          size="small"
          InputLabelProps={{ shrink: true }}
        />
      )}
    </ReactInputMask>
  );
}

Input.propTypes = {
  disabled: PropTypes.bool,
  onChangeInput: PropTypes.func.isRequired,
  error: PropTypes.bool,
};

Input.defaultProps = {
  disabled: false,
  error: false,
};
